export class MapMatchQuality {
  public readonly vildLocNr: number;
  public readonly vildVersionId: number;
  public readonly quality: number;
}



// WEBPACK FOOTER //
// ./src/app/models/mapmatchquality.ts